import { Provider } from '@angular/core';

import { provide } from '@kros-sk/core/di';

import { APPLICATION_SUBMODULES_API_URL, ApplicationSubmodulesApiService } from './application-submodules-api.service';
import { ApplicationSubmodulesStore } from './application-submodules.store';

export interface SubmodulesConfig {
  apiUrlSubmodules: string;
}

export function provideSubmodules(config: SubmodulesConfig): Provider[] {
  return [
    provide(APPLICATION_SUBMODULES_API_URL, { useValue: config.apiUrlSubmodules }),
    ApplicationSubmodulesApiService,
    ApplicationSubmodulesStore,
  ];
}
